const invoicesWithoutOccurrences = (state) => {
  return state.summaryDatatable.total_occurrences === 0
}

export default {
  invoicesWithoutOccurrences
}



// WEBPACK FOOTER //
// ./src/features/dashboard/store/getters.js